import { Component, Input, OnInit } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { isDefined } from '@fi-shared/utils';
import {
    ControlValueAccessorBase,
    ControlValueAccessorValidatorBase,
} from '@fi-shared/control-value-accessor-validator-base';
import { PublicationSettingModel } from '@fi-shared/models';
import { MatFormFieldAppearance } from '@angular/material/form-field';

@Component({
    selector: 'fi-select-period',
    template: `
        <div class="period-content">
          <!--{{ ngModel[getStartDatePropertyName()] }}<br>-->
          <fi-date-picker
            class="date-start"
            [label]="'common.start_date' | fiAppText"
            [(ngModel)]="ngModel[getStartDatePropertyName()]"
            (ngModelChange)="onModelChange()"
            [ngDisabled]="ngDisabled"
            [appearance]="appearance"
            [minDate]="minStartDate"
            [isInputInvalid]="isInputInvalid"
            [inputErrorTextLabel]="inputErrorTextLabel"
            [isStandardFormField]="isStandardFormField"
            [maxDate]="getMaxStartDate()"
            >
          </fi-date-picker>
        
          @if (isTimeLimited !== false) {
            <span class="period-divider"></span>
          }
        
          <!--<br>{{ngModel[getEndDatePropertyName()] }}<br>-->
          @if (isTimeLimited !== false) {
            <fi-date-picker
              class="date-end"
              [label]="'common.end_date' | fiAppText"
              [(ngModel)]="publicationEndDate"
              (ngModelChange)="onModelChange()"
              [ngDisabled]="ngDisabled"
              [appearance]="appearance"
              [isInputInvalid]="isInputInvalid"
              [inputErrorTextLabel]="inputErrorTextLabel"
              [isStandardFormField]="isStandardFormField"
              [minDate]="getMinEndDate()"
              >
            </fi-date-picker>
          }
        </div>
        `,
    styleUrls: ['./select-period.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: SelectPeriodComponent,
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: SelectPeriodComponent,
            multi: true,
        },
    ],
    standalone: false,
})
export class SelectPeriodComponent
    extends ControlValueAccessorValidatorBase<PublicationSettingModel>
    implements OnInit
{
    @Input() appearance: MatFormFieldAppearance;
    @Input() selectPeriodSettings;
    @Input() ngDisabled: boolean;
    @Input() isTimeLimited: boolean;
    @Input() minStartDate: string;
    @Input() isInputInvalid: boolean;
    @Input() inputErrorTextLabel: string;
    @Input() isStandardFormField: boolean = false;

    private _publicationEndDate: Date;
    get publicationEndDate() {
        if (!this._publicationEndDate && this.ngModel[this.getEndDatePropertyName()]) {
            return (this._publicationEndDate = new Date(
                this.ngModel[this.getEndDatePropertyName()].getTime() - (86400000 - 1000),
            )); // subtract 23:59:59
        }
        return this._publicationEndDate;
    }
    set publicationEndDate(value) {
        if (value) {
            this._publicationEndDate = value;
            this.ngModel[this.getEndDatePropertyName()] = new Date(value.getTime() + (86400000 - 1000)); // add 23:59:59
        } else {
            this._publicationEndDate = undefined;
            this.ngModel[this.getEndDatePropertyName()] = undefined;
        }
    }

    ngOnInit(): void {
        if (typeof this.ngModel[this.getStartDatePropertyName()] === typeof '') {
            this.ngModel[this.getStartDatePropertyName()] = new Date(this.ngModel[this.getStartDatePropertyName()]);
        }
        if (typeof this.ngModel[this.getEndDatePropertyName()] === typeof '') {
            this.ngModel[this.getEndDatePropertyName()] = new Date(this.ngModel[this.getEndDatePropertyName()]);
        }
    }

    getMaxStartDate() {
        return this.isTimeLimited ? this.ngModel[this.getEndDatePropertyName()] : null;
    }

    getMinEndDate() {
        return this.isTimeLimited ? this.ngModel[this.getStartDatePropertyName()] : null;
    }

    getStartDatePropertyName() {
        return isDefined(this.selectPeriodSettings) && isDefined(this.selectPeriodSettings.StartTimeProperty)
            ? this.selectPeriodSettings.StartTimeProperty
            : 'StartTime';
    }

    getEndDatePropertyName() {
        return isDefined(this.selectPeriodSettings) && isDefined(this.selectPeriodSettings.EndTimeProperty)
            ? this.selectPeriodSettings.EndTimeProperty
            : 'EndTime';
    }

    onModelChange() {
        super.doPropagateChanges();
    }
}
